import type { FunctionComponent, PropsWithChildren } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';
import { DeepFieldCanvasGraph } from '~/ui/domain/skill-graph/DeepFieldCanvasGraph';

import { COLLAPSED_NAV_WIDTH_PX } from '../../app-bar/menu-bar-v2/NavigationMenuContext';
import { useColorScheme } from '../../color-scheme/ColorSchemeProvider';

export const OnboardingContainer: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { colorScheme } = useColorScheme();
    const {
        applicationState: { language },
    } = useApplicationContext();

    return (
        <div className="relative flex min-h-screen w-full overflow-hidden bg-surface-canvas">
            <div
                aria-hidden={true}
                className="pointer-events-none absolute inset-0 z-0 overflow-hidden bg-surface-canvas"
            >
                <div className="absolute inset-[-8%] opacity-[var(--semantic-background-art-opacity)] [mix-blend-mode:var(--semantic-background-art-blend-mode)]">
                    <DeepFieldCanvasGraph
                        appearance={colorScheme}
                        className="relative h-full w-full"
                        config={{ enableDrag: false }}
                        height="100%"
                        languageCode={language.code}
                    />
                </div>
                <div className="absolute inset-0 bg-surface-canvas opacity-[var(--semantic-background-overlay-opacity)]" />
            </div>
            <div className="relative z-10 flex min-h-screen w-full flex-col">
                <main
                    className="flex flex-1 items-stretch justify-start overflow-hidden pr-m pb-m pt-xxs"
                    style={{
                        paddingLeft: `calc(var(--spacing-xxs) + var(--spacing-m) + ${COLLAPSED_NAV_WIDTH_PX}px)`,
                    }}
                >
                    {children}
                </main>
            </div>
        </div>
    );
};
